export interface Jwt {
  exp: number;
  iat: number;
  auth_time: number;
  jti: string;
  iss: string;
  aud: string;
  sub: string;
  typ: string;
  azp: string;
  session_state: string;
  acr: string;
  'allowed-origins': string[];
  realm_access: RealmAccess;
  resource_access: ResourceAccess;
  scope: string;
  sid: string;
  email_verified: boolean;
  name: string;
  preferred_username: string;
  given_name: string;
  family_name: string;
  email: string;
}

export interface RealmAccess {
  roles: string[];
}

// Typescript mapping of the mapped resource name and roles in /kubernetes/base/clients.yaml
export const bamClientResourceName = 'bam-client-frontend';
export const bamClientFrontendRaadplegen = 'bam_client_frontend_raadplegen';
export const bamClientFrontendMuteren = 'bam_client_frontend_muteren';
export const bamClientFrontendDefecten = 'bam_client_frontend_defecten';
export const bamClientFrontendBregelingenMeekijken = 'bam_client_frontend_bregelingen_meekijken';
export const bamClientFrontendBregelingenAccepteren = 'bam_client_frontend_bregelingen_accepteren';
export const bamClientFrontendBregelingenSluiten = 'bam_client_frontend_bregelingen_sluiten';
export const bamClientFrontendDdpMeekijken = 'bam_client_frontend_ddp_meekijken';
export const bamClientFrontendDdpMuteren = 'bam_client_frontend_ddp_muteren';
export const bamClientFrontendAgendaMeekijken = 'bam_client_frontend_agenda_meekijken';
export const bamClientFrontendAgendaMuteren = 'bam_client_frontend_agenda_muteren';
export const bamClientFrontendAgendaPlannen = 'bam_client_frontend_agenda_plannen';
export const bamClientFrontendBeheren = 'bam_client_frontend_beheren';
export const bamClientFrontendMatbeheren = 'bam_client_frontend_matbeheren';
export const bamClientFrontendTam = 'bam_client_frontend_tam';
export const bamClientFrontendInregelingen = 'bam_client_frontend_inregelingen';
export const bamClientFrontendSolver = 'bam_client_frontend_solver';
export const bamClientOpstelCapaciteit = 'bam_client_frontend_opstelcapaciteit';
export const bamClientLmm = 'bam_client_frontend_lmm';

export interface ResourceAccess {
  [bamClientResourceName]: RealmAccess;
  account: RealmAccess;
}
